import type { ValueOf } from '@vy/utils';

export const SIDE_NAV_BAR_ROUTES = Object.freeze({
  Home: '/home/overview',
  AiAgents: '/ai-agents',
  Customers: '/customers',
  Plans: '/plans',
  Invoices: '/invoices',
  Overview: '/invoices/overview',
  Payments: '/invoices/payments',
  Usage: '/usage/metering',
  Events: '/usage/events',
  DataMetering: '/usage/metering',
  Integrations: '/integrations',
  Products: '/products',
  Reports: '/reports',
});

export type SideNavBarRoute = ValueOf<typeof SIDE_NAV_BAR_ROUTES>;
